module.exports = __webpack_public_path__ + "static/img/cash_100000.0041f73.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/prizes/cash_100000.png
// module id = pS0J
// module chunks = 1